import { styled } from 'troyfe'

const Block = styled.div`
  flex: 1;
  .form {
    width: 74%;
    margin: 40px auto 0;
    input,
    .ant-select-selector {
      height: 48px;
      color: #1b1b1d;
      font-size: 16px;
      font-weight: 500;
    }
    .ant-form-item-control-input-content {
      height: 48px;
    }
    .ant-input-affix-wrapper-lg {
      padding: 0 11px;
    }
    .ant-input-group-addon {
      padding: 0;
      height: 48px;
    }
    .ant-select-single .ant-select-selector .ant-select-selection-item {
      line-height: 48px;
      font-size: 18px;
    }
    .ant-select-selection-placeholder {
      line-height: 48px;
    }
    .ant-form-item-label {
      width: 22.5%;
    }
    .ant-form-item-label > label {
      height: 48px;
      justify-content: flex-end;
      font-size: 16px;
      font-weight: 500;
    }
  }
  .cancel,
  .confirm {
    width: 120px;
    height: 52px;
  }
  .cancel,
  .modal-cancel {
    background: #fff;
    border: 1px solid #44bb55;
    color: #44bb55;
  }
  .confirm {
    margin-left: 20px;
  }
  .confirm,
  .modal-confirm {
    background-color: #44bb55;
    border-color: #44bb55;
    margin-left: 20px;
    color: #fff;
  }
  .handle {
    display: flex;
    margin-left: 22.5%;
    margin-top: 16px;
  }
  .modal {
    text-align: center;
    .modal-handle {
      margin-top: 40px;
      padding-bottom: 40px;
    }
    .modal-cancel,
    .modal-confirm {
      width: 200px;
      height: 52px;
    }
    .modal-confirm {
      margin-left: 40px;
    }
  }
`

export default Block
